import { defineStore } from 'pinia'
import { labelsAPI, filterAPI } from '../services/api'

export const useLabelsStore = defineStore('labels', {
    state: () => ({
        labels: [], // flat list
        groupedLabels: { category: [], subcategory: [], tag: [] },
        productLabels: {}, // productId -> [labels]
        filterLabelIds: [],
        filteredProducts: [],
        filterPagination: null,
        loading: false,
        error: null
    }),
    actions: {
        async fetchLabels(type) {
            this.loading = true
            try {
                const res = await labelsAPI.getLabels(type)
                this.labels = res.data
            } catch (err) {
                this.error = err
            } finally {
                this.loading = false
            }
        },
        async fetchLabelsGrouped() {
            this.loading = true
            try {
                const res = await labelsAPI.getLabelsGrouped()
                this.groupedLabels = res.data
            } catch (err) {
                this.error = err
            } finally {
                this.loading = false
            }
        },
        async fetchProductLabels(productId) {
            try {
                const res = await labelsAPI.getProductLabels(productId)
                this.productLabels[productId] = res.data
            } catch (err) {
                this.error = err
            }
        },
        async assignLabels(productId, labelIds) {
            try {
                await labelsAPI.assignLabels(productId, labelIds)
                await this.fetchProductLabels(productId)
            } catch (err) {
                this.error = err
            }
        },
        async removeProductLabel(productId, labelId) {
            try {
                await labelsAPI.removeProductLabel(productId, labelId)
                await this.fetchProductLabels(productId)
            } catch (err) {
                this.error = err
            }
        },
        async filterProductsByLabels(labelIds, page = 1) {
            this.loading = true
            console.log('Filtering products by labels:', labelIds, 'page:', page)
            try {
                const res = await filterAPI.filterProducts(labelIds, page)
                console.log('Filter response:', res)
                this.filteredProducts = res.data.products
                this.filterLabelIds = labelIds
                this.filterPagination = res.data.pagination
            } catch (err) {
                console.error('Filter error:', err)
                this.error = err
            } finally {
                this.loading = false
            }
        },
        async deleteLabel(id) {
            try {
                await labelsAPI.deleteLabel(id)
                await this.fetchLabelsGrouped()
            } catch (err) {
                this.error = err
            }
        },
        async createLabel(data) {
            try {
                await labelsAPI.createLabel(data)
                await this.fetchLabelsGrouped()
            } catch (err) {
                this.error = err
                throw err // Re-throw the error so component can handle it
            }
        },
        async updateLabel(id, data) {
            try {
                await labelsAPI.updateLabel(id, data)
                await this.fetchLabelsGrouped()
            } catch (err) {
                this.error = err
                throw err // Re-throw the error so component can handle it
            }
        },
        clearFilter() {
            this.filterLabelIds = []
            this.filteredProducts = []
            this.filterPagination = null
        }
    }
}) 